
import * as React from "react";
import { IIconProps } from "./Icon";

const Icon = (props: IIconProps) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={props.width}
    className={`svg-icon ${props.className || ""}`}
    height={props.width}
    viewBox="0 0 512 512">

    <g id="surface1">
    <path 
        d="M 12.398438 372 L 372 372 L 372 12.398438 L 12.398438 12.398438 Z M 55.800781 167.398438 L 167.398438 167.398438 L 167.398438 55.800781 L 217 55.800781 L 217 167.398438 L 328.601562 167.398438 L 328.601562 217 L 217 217 L 217 328.601562 L 167.398438 328.601562 L 167.398438 217 L 55.800781 217 Z M 55.800781 167.398438 " 
        style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(50.196078%,46.27451%,30.196078%)',
            fillOpacity:1
        }} />
    <path 
        d="M 173.597656 334.800781 L 223.199219 334.800781 L 223.199219 223.199219 L 334.800781 223.199219 L 334.800781 173.597656 L 223.199219 173.597656 L 223.199219 62 L 173.597656 62 L 173.597656 173.597656 L 62 173.597656 L 62 223.199219 L 173.597656 223.199219 Z M 173.597656 334.800781 " 
        style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(50.196078%,46.27451%,30.196078%)',
            fillOpacity:1
        }} />
    <path 
        d="M 6.199219 365.800781 L 365.800781 365.800781 L 365.800781 6.199219 L 6.199219 6.199219 Z M 49.597656 161.199219 L 161.199219 161.199219 L 161.199219 49.597656 L 210.800781 49.597656 L 210.800781 161.199219 L 322.398438 161.199219 L 322.398438 210.800781 L 210.800781 210.800781 L 210.800781 322.398438 L 161.199219 322.398438 L 161.199219 210.800781 L 49.597656 210.800781 Z M 49.597656 161.199219 " 
        style={{
            stroke:'none',
            fillRule: 'nonzero',
            fill:'rgb(0%,84.313725%,87.45098%)',
            fillOpacity: 1
        }} />
    <path 
        d="M 161.199219 322.402344 L 210.800781 322.402344 L 210.800781 210.800781 L 322.402344 210.800781 L 322.402344 161.199219 L 210.800781 161.199219 L 210.800781 49.597656 L 161.199219 49.597656 L 161.199219 161.199219 L 49.597656 161.199219 L 49.597656 210.800781 L 161.199219 210.800781 Z M 161.199219 322.402344 " 
        style={{
            stroke:'none',
            fillRule:'nonzero',
            fill:'rgb(100%,31.372549%,13.72549%)',
            fillOpacity:1
        }} />
    <path 
        d="M 365.800781 0 L 6.199219 0 C 2.777344 0 0 2.777344 0 6.199219 L 0 365.800781 C 0 369.226562 2.777344 372 6.199219 372 L 365.800781 372 C 369.226562 372 372 369.226562 372 365.800781 L 372 6.199219 C 372 2.777344 369.222656 0 365.800781 0 Z M 359.601562 359.601562 L 12.398438 359.601562 L 12.398438 12.398438 L 359.601562 12.398438 Z M 359.601562 359.601562 " 
        style={{
            stroke:'none',
            fillRule:'nonzero',
            fill:'rgb(13.72549%,12.156863%,12.54902%)',
            fillOpacity:1
        }} />
    <path 
        d="M 49.597656 217 L 155 217 L 155 322.398438 C 155 325.824219 157.773438 328.601562 161.199219 328.601562 L 210.800781 328.601562 C 214.222656 328.601562 217 325.824219 217 322.398438 L 217 217 L 322.398438 217 C 325.824219 217 328.601562 214.222656 328.601562 210.800781 L 328.601562 161.199219 C 328.601562 157.773438 325.824219 155 322.398438 155 L 217 155 L 217 49.597656 C 217 46.175781 214.222656 43.398438 210.800781 43.398438 L 161.199219 43.398438 C 157.773438 43.398438 155 46.175781 155 49.597656 L 155 155 L 49.597656 155 C 46.175781 155 43.398438 157.773438 43.398438 161.199219 L 43.398438 210.800781 C 43.398438 214.222656 46.175781 217 49.597656 217 Z M 55.800781 167.398438 L 161.199219 167.398438 C 164.625 167.398438 167.398438 164.625 167.398438 161.199219 L 167.398438 55.800781 L 204.601562 55.800781 L 204.601562 161.199219 C 204.601562 164.625 207.375 167.398438 210.800781 167.398438 L 316.199219 167.398438 L 316.199219 204.601562 L 210.800781 204.601562 C 207.375 204.601562 204.601562 207.375 204.601562 210.800781 L 204.601562 316.199219 L 167.398438 316.199219 L 167.398438 210.800781 C 167.398438 207.375 164.625 204.601562 161.199219 204.601562 L 55.800781 204.601562 Z M 55.800781 167.398438 " 
        style={{
            stroke:'none',
            fillRule:'nonzero',
            fill:'rgb(13.72549%,12.156863%,12.54902%)',
            fillOpacity:1
        }} />
    </g>  
  </svg>
);

export default Icon;
